function searchService(
  $q,
  $log,
  $translate,
  $location,
  $rootScope,
  storyProcessingService,
  filtersService,
  refreshChecker,
  layoutService,
  urlService,
  storiesService,
  _,
  analyticsService,
  $http,
  Story,
  Task
) {
  const service = {
    searches: {}
  };

  // search implementations for different search types
  service.searchStories = (search, getAllStoriesDownToPage) => {
    const deferred = $q.defer();

    if (!search || !search.filterSet) {
      deferred.reject('NO_SEARCH_OBJECT');
    }

    const searchParams = service.getStoriesParams(search, getAllStoriesDownToPage);

    let termOrTbd = false;
    if (
      searchParams.tbd
      || searchParams.searchTerm
      || searchParams.author
      || searchParams.authorID
      || searchParams.headline
      || searchParams.slug
      || searchParams.sourceId
    ) {
      termOrTbd = true;
    }

    if (searchParams.sort === 'relevance' && !termOrTbd) {
      const error = $translate.instant('PLEASE_ENTER_SEARCH_TERM');
      deferred.reject({ error });
    } else {
      storiesService.getStories(searchParams)
        .then((storyData) => {
          const data = storyData;
          if (!search || !search.filterSet) {
            throw new Error('No search object');
          }

          const platformFilterValue = search.filterSet.getFilterValue('platforms');

          const config = {};
          if (platformFilterValue) {
            config.platform = search.filterSet.getFilterValue('platforms');
          }

          if (Array.isArray(config.platform) && config.platform.length) {
            config.platform = config.platform[0];
          }

          data.results = Array.isArray(data.results)
            ? data.results.map(story => new Story(story, config))
            : [];

          storyProcessingService.addTimebreaksToList(data.results);
          deferred.resolve(data);
        }, (data) => {
          deferred.reject(data);
        });
    }

    return deferred.promise;
  };

  function getPlansArray(val) {
    const iterationTarget = [].concat(val);
    return _.each(iterationTarget, (i, key) => {
      iterationTarget[key] = i.replace(/\/$/, '');
    });
  }

  function arrayNotEmpty(value) {
    let result = false;

    if (Array.isArray(value) && value.length > 0) {
      result = true;
    }

    return result;
  }

  service.getStoriesParams = (currentSearch, getAllStoriesDownToPage) => {
    const search = currentSearch;
    let platformsParam;
    let platform = search.filterSet.getFilterValue('platforms');

    if (platform && !_.isArray(platform)) {
      platform = [platform];
    }

    if (platform && arrayNotEmpty(platform)) {
      platformsParam = platform;
    } else {
      platformsParam = null;
    }

    let sectionsParam;
    const sections = search.filterSet.getFilterValue('sections');

    if (sections) {
      sectionsParam = getPlansArray(sections);
    } else {
      sectionsParam = '/';
    }

    // TODO: safe to delete 'getAllStoriesDownToPage'??
    const searchParams = {
      size: search.filterSet.getFilterValue('size') ? search.filterSet.getFilterValue('size') : 20,
      sections: sectionsParam,
      platforms: platformsParam,
      page: getAllStoriesDownToPage ? 0 : search.state.pageNumber,
      searchTerm: search.filterSet.getFilterValue('searchTerm'),
      author: search.filterSet.getFilterValue('author'),
      authorID: search.filterSet.getFilterValue('authorID'),
      headline: search.filterSet.getFilterValue('headline'),
      slug: search.filterSet.getFilterValue('slug'),
      sourceId: search.filterSet.getFilterValue('sourceId'),
      inheritance: search.filterSet.getFilterValue('childPlans') !== 'off',
      pitchStatus: search.filterSet.getFilterValue('pitchStatus'),
      pitchesOnly: search.filterSet.getFilterValue('pitchesOnly'),
      publishStatus: search.filterSet.getFilterValue('publishStatus'),
      workflowStatus: search.filterSet.getFilterValue('workflowStatus'),
      contentType: search.filterSet.getFilterValue('contentType'),
      sourceType: search.filterSet.getFilterValue('sourceType'),
      distributorId: search.filterSet.getFilterValue('distributorId'),
      distributorName: search.filterSet.getFilterValue('distributorName'),
      content: search.filterSet.getFilterValue('sponsored'),
      asc: search.filterSet.getFilterValue('direction') !== 'desc',
      tbd: search.filterSet.getFilterValue('tbd'),
      sort: search.filterSet.getFilterValue('sortOrder') || 'time',
      plannedTimeAccuracy: search.filterSet.getFilterValue('plannedTimeAccuracy'),
      live: search.filterSet.getFilterValue('live'),
      tags: search.filterSet.getFilterValue('tags'),
      primaryWebsites: search.filterSet.getFilterValue('websites')
    };

    if (!searchParams.tbd || searchParams.sort !== 'relevance') {
      if (!search.filterSet.getFilterValue('startDate')) {
        search.filterSet.getFilter('startDate').value = 'today';
      }

      searchParams.startDate = urlService.getEpochTime(search.filterSet.getFilterValue('startDate'));
      searchParams.endDate = urlService.getEpochTime(search.filterSet.getFilterValue('endDate'));
    }

    return searchParams;
  };

  service.searchTasks = (search, getAllTasksDownToPage) => {
    const deferred = $q.defer();
    if (!search || !search.filterSet) deferred.reject('NO_SEARCH_OBJECT');

    const params = {
      includeStories: true,
      page: getAllTasksDownToPage ? 0 : search.state.pageNumber,
      // HOTFIX: needs to be false by default
      asc: search.filterSet.getFilterValue('direction') === 'asc',
      type: search.filterSet.getFilterValue('taskType'),
      priority: search.filterSet.getFilterValue('taskPriority'),
      status: search.filterSet.getFilterValue('taskStatus'),
      sortBy: search.filterSet.getFilterValue('taskSort') === 'created' ? 'createdBy' : search.filterSet.getFilterValue('taskSort') || 'createdDate',
      createdBy: search.filterSet.getFilterValue('createdBy'),
      primaryWebsites: search.filterSet.getFilterValue('websites')
    };

    if (search.context.entity.type === 'group') {
      params.assignedGroup = search.context.entity.id;
    } else if (search.context.entity.type === 'user' && search.context.entity.id) {
      params.assignedUsers = search.context.entity.id;
    }

    analyticsService.trackPageview();

    Task.query(params, search.state.pageNumber, getAllTasksDownToPage).then((data) => {
      deferred.resolve(data);
    }, (response) => {
      deferred.reject(response);
    });

    return deferred.promise;
  };

  service.searchEdition = (search) => {
    const params = {
      page: search.state.pageNumber,
      sort: 'pitch',
      asc: search.filterSet.getFilterValue('direction') !== 'desc',
      edition: search.context.editionId,
      size: 20,
      publicationPitchStatus: search.context.publicationPitchStatus || search.filterSet.getFilterValue('pitchStatus'),
      primaryWebsites: search.filterSet.getFilterValue('websites')
    };

    return $http.get('/editorial-search/websked-search', { params })
      .then((response) => {
        const { results } = response.data;

        if (results) {
          const storyResults = results.map(story => (
            new Story(story, { publication: search.context.publicationId })));
          response.data.results = storyResults;
        }

        return response.data;
      });
  };

  // config for supported search types
  service.searchTypeConfigs = {
    stories: {
      matchBy: ['id', 'slug'],
      dataProperty: 'results',
      messages: {
        noMoreResults: 'NO_ADDITIONAL_STORIES_FOUND',
        noResults: 'NO_STORIES_FOUND',
        singleResult: 'ONE_STORY_FOUND',
        multipleResults: 'STORIES_FOUND'
      },
      refresh: {
        markAsNewProperty: 'isNew',
        elementIdPrefix: '',
        elementIdProperty: 'slug'
      },
      search: service.searchStories
    },
    tasks: {
      matchBy: ['id'],
      dataProperty: 'results',
      messages: {
        noMoreResults: 'SHOWING_ALL_TASKS',
        noResults: 'TASK_QUEUE_EMPTY_MSG',
        singleResult: 'ONE_TASK_FOUND',
        multipleResults: 'TASKS_FOUND'
      },
      refresh: {
        markAsNewProperty: 'isNew',
        elementIdPrefix: 'task_',
        elementIdProperty: 'id'
      },
      search: service.searchTasks
    },
    edition: {
      matchBy: ['id'],
      dataProperty: 'results',
      messages: {
        noMoreResults: 'NO_ADDITIONAL_STORIES_FOUND',
        noResults: 'NO_STORIES_FOUND',
        singleResult: 'ONE_STORY_FOUND',
        multipleResults: 'STORIES_FOUND'
      },
      refresh: {
        markAsNewProperty: 'isNew',
        elementIdPrefix: 'story_',
        elementIdProperty: 'id'
      },
      search: service.searchEdition
    }
  };


  service.moreAvailableCalculator = (search, data) => {
    if (search.type === 'stories' || search.type === 'edition') {
      return data.pageNumber < data.totalPages - 1;
    } else if (search.type === 'tasks') {
      // if there are no results this time, there definetly aren't any more out there.
      if (!data || !data.results) {
        return false;
      }

      if (data.results.length === data.pageSize) {
        // if the maximum number of results were returned, 
        // there might be more tasks out there
        return true;
      }
      // that's the last of the tasks for this query
      return false;
    }

    return true;
  };

  // service functions
  service.addAlert = (search, type, message) => {
    const duplicateAlert = search.state.alerts.find(alert => alert.msg === message);

    if (!duplicateAlert) {
      search.state.alerts.push({
        type,
        msg: message
      });
    }
  };

  service.clearAlerts = (currentSearch) => {
    const search = currentSearch;
    search.state.alerts = [];
  };

  // search data load functions

  service.loadItems = (currentSearch) => {
    const search = currentSearch;
    if (!search || !search.type) return;

    if (search.refresh) {
      search.refresh.stop();
    }
    // reset the state

    search.state.loading = true;
    search.state.pageNumber = 0;

    service.clearAlerts(search);

    search.results = search.settings.preserveResults ? search.results : [];

    function successCallback(data) {
      search.enableCallback();

      search.results = search.settings.dataProperty ? data[search.settings.dataProperty] : data;

      search.state.moreAvailable = service.moreAvailableCalculator(search, data);

      if (search.refresh) {
        search.refresh.start();
      }
      // show alert/toast with number of stories
      let message = $translate.instant(service.searchTypeConfigs[search.type].messages.noResults);
      if (!search.results) {
        let errorMessage = data && data.error ? data.error : data;
        errorMessage = $translate.instant('ERROR_LOADING_TASKS');
        service.addAlert(search, 'danger', errorMessage);
        return;
      }
      if (search.results.length && search.name !== 'editionSearch' && search.context.type !== 'edition') {
        message = search.results.length > 1 ? `${data.totalResults} ${$translate.instant(service.searchTypeConfigs[search.type].messages.multipleResults)}` :
          $translate.instant(service.searchTypeConfigs[search.type].messages.singleResult);

        if (data.totalResults) {
          layoutService.mobileToast('info', message);
        }

        if (!search.state.moreAvailable) {
          const translationId = service.searchTypeConfigs[search.type].messages.noMoreResults;
          message = $translate.instant(translationId);
          service.addAlert(search, 'warning', message);
        }
      } else if (search.name !== 'editionSearch' && search.context.type !== 'edition') {
        const alertType = search.type === 'tasks' ? 'success' : 'warning';
        service.addAlert(search, alertType, message);
        layoutService.mobileToast(alertType, message);
      }
    }

    service.searchTypeConfigs[search.type].search(search)
      .then(
        successCallback,
        (data) => {
          let errorMessage = data && data.error ? data.error : data;
          $log.error(`searchService getting ${search.type} error`, errorMessage);
          if (errorMessage === 'startDate must be less than endDate') {
            errorMessage = $translate.instant('START_END_DATE_ERROR1');
          } else if (search.filterSet.filters.searchTerm && !search.filterSet.filters.searchTerm.value && search.urlState.sort === 'relevance') {
            errorMessage = $translate.instant('ERROR_LOADING_STORIES_BY_RELEVANCE');
          } else if (search.type === 'stories' || search.type === 'edition') {
            errorMessage = $translate.instant('ERROR_LOADING_STORIES');
          } else {
            errorMessage = $translate.instant('ERROR_LOADING_TASKS');
          }

          service.addAlert(search, 'danger', errorMessage);
          layoutService.mobileToast(errorMessage);
        }
      )
      .finally(() => {
        search.state.loading = false;
      });
  };

  // loading more items on demand
  service.loadMoreItems = (currentSearch) => {
    const search = currentSearch;
    if (!search || !search.type || !search.state.moreAvailable) return;

    search.state.loadingMore = true;
    search.state.pageNumber += 1;

    service.searchTypeConfigs[search.type].search(search)
      .then(
        (data) => {
          const results = search.settings.dataProperty ? data[search.settings.dataProperty] : data;

          search.state.moreAvailable = service.moreAvailableCalculator(search, data);

          if (results.length) {
            search.results = Array.from(search.results.concat(results));
          }

          if (!search.state.moreAvailable) {
            service.addAlert(search, 'warning', $translate.instant(service.searchTypeConfigs[search.type].messages.noMoreResults));
          }

          search.enableCallback();
        },
        (response) => {
          $log.error('searchService service.gettingMoreItems() error', response);
          let message;
          if (search.type === 'stories' || search.type === 'edition') {
            message = $translate.instant('ERROR_LOADING_STORIES');
          } else {
            message = $translate.instant('ERROR_LOADING_TASKS');
          }

          service.addAlert(search, 'danger', message);
          layoutService.mobileToast(message);
        }
      )
      .finally(() => {
        search.state.loadingMore = false;
      });
  };

  // search object

  service.getSearch = (context) => {
    if (!service.searchTypeConfigs[context.type]) {
      return null;
    }

    service.searches[context.name] = new service.Search(context);
    return service.searches[context.name];
  };

  service.search = (context) => {
    const search = service.getSearch(context);
    if (search) {
      search.init();
    }

    return search;
  };

  service.deleteSearch = (search) => {
    const searchName = _.isObject(search) ? search.name : search;
    if (searchName) {
      delete service.searches[searchName];
    }
  };

  service.Search = function Search(context) {
    const search = this;

    this.settings = service.searchTypeConfigs[context.type];

    if (!this.settings) {
      throw new Error({ name: 'SearchException', message: 'ERROR' });
    }

    this.name = context.name;
    this.type = context.type;
    this.publicationId = context.publicationId;
    this.context = context;

    this.state = {
      loading: true,
      loadingMore: false,
      pageNumber: 0,
      alerts: []
    };

    this.results = [];

    this.changeDebounce = 350;

    // expose search lifecycle controls to UI
    this.load = function load() {
      service.loadItems(search);
    };
    this.loadMore = function loadMore() {
      if (!search.state.loading) {
        service.loadMoreItems(search);
      }
    };
    this.tearDown = function tearDown() {
      if (search.refresh) search.refresh.stop();
      if (search.locationWatcher) search.locationWatcher();

      search.initialized = false;
    };
  };

  service.Search.prototype.updateLocation = function updateLocation() {
    // Location update logic
    this.enableLoadCallback = false;
    this.load();

    if (!this.skipLocationUpdate) {
      this.urlState = _.assign(
        {},
        this.filterSet.buildQueryParams(),
        this.filterSet.getNonFilterParams(this.urlState)
      );
      $location.search(this.urlState);
    }
    this.skipLocationUpdate = false;
  };

  const { updateLocation, changeDebounce } = service.Search.prototype;
  service.Search.prototype.triggerSearchUpdate = _.debounce(updateLocation, changeDebounce);

  service.Search.prototype.enableCallback = function enableCallback() {
    this.enableLoadCallback = true;
  };

  service.Search.prototype.disableCallback = function disableCallback() {
    this.enableLoadCallback = false;
  };

  service.Search.prototype.matchUrlState = function matchState(prevState, currentState) {
    const cleanPrevState = angular.copy(prevState);
    const cleanCurrentState = angular.copy(currentState);

    _.forOwn(cleanPrevState, (value, key) => {
      if (_.startsWith(key, '_')) {
        delete cleanPrevState[key];
      }
    });

    _.forOwn(cleanCurrentState, (value, key) => {
      if (_.startsWith(key, '_')) {
        delete cleanPrevState[key];
      }
    });

    return _.isEqual(cleanPrevState, cleanCurrentState);
  };

  // main search init
  service.Search.prototype.init = function init() {
    const search = this;

    search.initialized = true;

    // init refresh if enabled
    if (search.context.refresh) {
      const dataRefresh = () => service.searchTypeConfigs[search.type].search(search, true);

      const dataReload = () => {
        const load = $q.defer();

        if (search.state.pageNumber > 0) {
          service.clearAlerts(search);
          search.state.moreAvailable = true;
          search.state.pageNumber = 0;
        }

        service.searchTypeConfigs[search.type].search(search, true)
          .then((data) => {
            const { dataProperty } = search.settings;
            search.results = dataProperty ? data[dataProperty] : data;

            load.resolve({
              data: search.results,
              markAsNewProperty: search.settings.refresh.markAsNewProperty,
              elementIdPrefix: search.settings.refresh.elementIdPrefix,
              elementIdProperty: search.settings.refresh.elementIdProperty
            });

            if (!search.state.moreAvailable) {
              service.clearAlerts(search);
              const translationId = service.searchTypeConfigs[search.type].messages.noMoreResults;
              const noMoreMessage = $translate.instant(translationId);
              service.addAlert(search, 'warning', noMoreMessage);
            }
          }, (error) => {
            load.reject(error);
          });
        return load.promise;
      };

      search.refresh = refreshChecker.createRefresh(search);

      search.refresh.init({
        matchBy: search.settings.matchBy,
        dataProperty: search.settings.dataProperty,
        view: search.type
      }, dataRefresh, dataReload);
    }

    // init filters
    search.urlState = $location.search();
    search.filterSet = filtersService.createFilterSet(search.urlState, search);

    // init location watcher
    search.enableLoadCallback = false;
    search.skipLocationUpdate = false;

    search.locationWatcher = $rootScope.$on('$locationChangeSuccess', () => {
      if (search.enableLoadCallback && !search.matchUrlState(search.urlState, $location.search())) {
        // make url snapshot
        search.urlState = $location.search();

        search.filterSet.buildFilters($location.search(), true);
        search.skipLocationUpdate = true;

        search.triggerSearchUpdate();
      }
      search.enableLoadCallback = true;
    });

    // do initial load
    search.initialized = true;
    search.load();

    return search;
  };

  return service;
}

const arr = [
  '$q',
  '$log',
  '$translate',
  '$location',
  '$rootScope',
  'storyProcessingService',
  'filtersService',
  'refreshChecker',
  'layoutService',
  'urlService',
  'storiesService',
  '_',
  'analyticsService',
  '$http',
  'Story',
  'Task',
  searchService
];

export default function (ngModule) {
  ngModule.factory('searchService', arr);
}
